import { render, staticRenderFns } from "./PlanLegacy.vue?vue&type=template&id=825d5fce&scoped=true&lang=pug"
import script from "./PlanLegacy.vue?vue&type=script&lang=js"
export * from "./PlanLegacy.vue?vue&type=script&lang=js"
import style0 from "./PlanLegacy.vue?vue&type=style&index=0&id=825d5fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825d5fce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrugsMonthlyByDrug: require('/home/docker/code/frontend/components/DrugsMonthlyByDrug.vue').default,PlanProvidersList: require('/home/docker/code/frontend/components/PlanProvidersList.vue').default})
